import React from "react";
//import PropTypes from 'prop-types';
import { DropTarget } from "react-dnd";
import Avatar from "material-ui/Avatar";
import AvatarIcon from "material-ui/svg-icons/action/account-circle";
import { connect } from "../../utils";

const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(
        props.id,
        props.children.length,
        monitor.getItem()
      );
    }
  }
};
const EditLayout = ({
  id,
  children,
  isOverCurrent,
  connectDropTarget,
  type,
  layoutState,
  readOnly
}) => {
  const { containerPadding, url, size, align } = layoutState.getItemJS(
    id
  ).props.values;
  const srcAvatar =
    url || "https://via.placeholder.com/200x200?text=200x200=CMS";
  return connectDropTarget(
    <div
      style={{
        boxSizing: "border-box",
        position: "relative",
        height: "100%",
        display: "flex",
        padding: containerPadding,
        flex: 1,
        justifyContent: align
      }}
    >
      <Avatar
        icon={<AvatarIcon />}
        color="#FFFFFF"
        src={srcAvatar}
        backgroundColor="#CFD8DC"
        size={size}
      />
    </div>
  );
};

const LayoutContainer = DropTarget("AvatarView", target, (conn, monitor) => ({
  connectDropTarget: conn.dropTarget(),
  isOverCurrent: monitor.isOver({ shallow: true })
}))(EditLayout);

export default connect("layoutState", "readOnly")(LayoutContainer);



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDAvatar.js